import React from 'react'
import PropTypes from 'prop-types'
import { renderEventName } from '../../util/names'


const TransitionList = ({ taskReadOnly, task, availableTransitionList, validateAndTriggerEvent }) => {
    if (taskReadOnly || task.status === 'skipped' || task.status === 'finished') {
        return null
    }
    return (
        <React.Fragment>
            {
                availableTransitionList.map((transition) => {
                    let { className, eventName, technicalEvent, isAllowedForUser } = transition
                    if (technicalEvent || !isAllowedForUser) {
                        return null
                    }
                    className += ` btn btn-sm ${task.name} ${eventName}`
                    return (
                        <span key={eventName}>
                            <button className={className} onClick={() => {
                                validateAndTriggerEvent(task.name, eventName)
                            }}
                            >
                                {renderEventName(eventName)}
                            </button>

                            &#160;</span>
                    )
                })
            }
        </React.Fragment>
    )
}


TransitionList.propTypes = {
    taskReadOnly: PropTypes.bool.isRequired,
    task: PropTypes.object.isRequired,
    availableTransitionList: PropTypes.array.isRequired,
    validateAndTriggerEvent: PropTypes.func.isRequired,
}

export default TransitionList



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TransitionList.js